// extracted by mini-css-extract-plugin
export default {"notice":"notice_notice__Y-No8","title":"notice_title__V2ImV","detail":"notice_detail__3xx19"};